<script setup>
import { useGlobalStore } from '@/stores/global'
import Button from './Button.vue'

const props = defineProps(['links','isScrolled'])
const global = useGlobalStore()
</script>

<template>
    <div class="fixed z-40 top-0 left-0 w-full h-full bg-carbon-200 transition-all lg:hidden flex items-center text-white">
        <div class="container">
            <div class="flex flex-col gap-8 items-start text-3xl uppercase font-bold">
                <router-link :to="{ name: 'index', hash: link.hash }" v-for="link, i in links" :key="i" @click="global.toggleMobile()">{{ link.title }}</router-link>
                <Button href="https://docs.google.com/forms/d/1jPCVRXX15kLNOu9910QXpjmMF0mgVM8PylAWHbEVLfg/viewform?edit_requested=true" @click="global.toggleMobile()">Apply Now</Button>
            </div>
        </div>
    </div>
</template>